import { MemberDetailsDto } from './memberdetailsdto';

export interface GroupDto
{
    getServiceName():string;
    getMsisdnB():string;
    getGroupId():string;
    getGroupName():string;
    getGroupDesc():string;
    getIsBlocked():string;
    getDeletedMembersList(): string[];
    getMembersList(): MemberDetailsDto[];
    getId(): string;
}

export class GroupDtoImpl implements GroupDto
{
   
    private serviceName: string;
    private msisdnB: string;
    private groupId: string;
    private groupName: string;
    private groupDesc: string;
    private isBlocked: string;
    private deletedMembersList: string[] = [];
    private membersList: MemberDetailsDto[];
    private id: string;

    getDeletedMembersList(): string[] {
       return this.deletedMembersList;
    }

    setDeletedMembersList(membersList: string[])
    {
        this.deletedMembersList = membersList;
    }

    setServiceName(serviceName: string)
    {
        this.serviceName = serviceName;
    }
    getServiceName(): string 
    {
        return this.serviceName;
    }

    setMsisdnB(msisdnB: string)
    {
        this.msisdnB = msisdnB;
    }
    getMsisdnB(): string 
    {
        return this.msisdnB;
    }

    setGroupId(groupId: string)
    {
        this.groupId = groupId;
    }
    getGroupId(): string 
    {
        return this.groupId;
    }

    setGroupName(groupName: string)
    {
        this.groupName = groupName;
    }
    getGroupName(): string 
    {
        return this.groupName;
    }

    
    setGroupDesc(groupDesc: string)
    {
        this.groupDesc = groupDesc;
    }
    getGroupDesc(): string 
    {
        return this.groupDesc;
    }
    
    setIsBlocked(isBlocked: string)
    {
        this.isBlocked = isBlocked;
    }
    getIsBlocked(): string 
    {
        return this.isBlocked;
    }

    setMembersList(membersList: MemberDetailsDto[])
    {
        this.membersList = membersList;
    }
    getMembersList(): MemberDetailsDto[] 
    {
        return this.membersList;
    }
 
    setId(id: string)
    {
        this.id = id;
    }
    getId(): string 
    {
        return this.id;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listtones/groupdto.tsx